import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'XML ticket',
      title: 'Get XML ticket',
      executeAction: 'Submit',
      errorMessage: 'Error',
    }
  }
}